"use client";

import React from "react";

import { createSVGIcon } from "../util";

/**
 * @deprecated use Search from foundation/Search
 * @trackcomponent
 */
export const Search = createSVGIcon(
  <>
    <g
      id="Icon-/-Navigation-/-Search-/-Default"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      transform="translate(1.000000, 0.000000)"
    >
      <g
        id="Search"
        transform="translate(0.000000, 0.727273)"
        stroke="currentColor"
        strokeWidth="1.1"
      >
        <ellipse
          id="Oval"
          cx="5.95833333"
          cy="6.23333333"
          rx="5.95833333"
          ry="6.23333333"
        />
        <path
          d="M10.3481445,11.0793679 L13.5,14.7727273"
          id="Line"
          strokeLinecap="square"
        />
      </g>
    </g>
  </>,
  "Search",
  { viewBox: "0 0 16 17", titleAccess: "Search" }
);
